import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminUtilityLoginComponent } from './admin-utility-login/admin-utility-login.component';
import { AdminUtilityComponentInfo } from './admin-utility.component';
import { AdminAffiliationComponent } from './admin-affiliation/admin-affiliation.component';
import { AdminAffiliationListComponent } from './admin-affiliation-list/admin-affiliation-list.component';
import { AdminZipcodeListComponent } from './admin-zipcode-list/admin-zipcode-list.component';
import { AdminZipcodeComponent } from './admin-zipcode/admin-zipcode.component';
import { AdminPromoCodeListComponent } from './admin-promocode-list/admin-promocode-list.component';
import { AdminPromoCodeComponent } from './admin-promocode/admin-promocode.component';
// import { AdminUtilityComponent } from './admin-utility/admin-utility.component';

const routes: Routes = [
  { path: 'hg-admin', component: AdminUtilityLoginComponent },
  { path: 'hg-admin-success', component: AdminUtilityComponentInfo },
  { path: 'hg-admin-affiliate-addedit', component: AdminAffiliationComponent },
  { path: 'hg-admin-affiliate-addedit/:id', component: AdminAffiliationComponent },
  { path: 'hg-admin-affiliate-list', component: AdminAffiliationListComponent },
  { path: 'hg-admin-zipcode-list', component: AdminZipcodeListComponent },
  { path: 'hg-admin-promocode-list', component: AdminPromoCodeListComponent },
  { path: 'hg-admin-promocode-addedit', component: AdminPromoCodeComponent },
  { path: 'hg-admin-promocode-addedit/:id', component: AdminPromoCodeComponent },
  { path: 'hg-admin-zipcode-addedit/:id', component: AdminZipcodeComponent },
  { path: 'hg-admin-zipcode-addedit', component: AdminZipcodeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminUtilityRoutingModule {}
